<template>
  <b-badge
    :variant="variant"
    class="badge-glow"
  >
    {{ text }}
  </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import { getColorByValue } from '../../common/utils/utils'

export default {
  name: 'DisplayStatus',
  components: {
    BBadge,
  },
  props: {
    value: {
      type: String,
      default: () => '',
    },
    text: {
      type: String,
      default: () => '',
    },
    size: {
      type: String,
      default: () => 'lg',
    },
  },
  computed: {
    variant() {
      return getColorByValue(this.value)
    },
  },
}
</script>

<style scoped></style>
